import { Controller } from '@hotwired/stimulus';
import debounce from 'lodash/debounce';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = [
        'stepsTabs',
        'stepsContents',

        'navContainer',
        'navElement',

        'bookButton',
        'form',
        'nextDatesSelect',
        'travelTourDatesContainer',

        'nextDatesError',
        'childrenAgeError',
        'childrenNumberError',

        'travellersDescription',
        'travellersStatus',
        'travellersTooltip',

        'minPrice',
    ];
    connect() {
        this.init();
    }

    disconnect() {
        // Remove all event listeners when controller disconnects
        window.removeEventListener('pageshow', this.resetFormState);
    }

    init() {
        /// scroll debounce
        window.addEventListener(
            'scroll',
            debounce(this.activateCurrentNavigationLink.bind(this), 100),
        );
        this.activateCurrentNavigationLink();

        // smooth scroll

        var headerLink = document.getElementById('header-link');

        this.navElementTargets?.forEach((navElement) =>
            navElement.addEventListener('click', (event) =>
                this.smoothScroll(event),
            ),
        );
        if (headerLink) {
            headerLink.addEventListener('click', (event) =>
                this.smoothScroll(event),
            );
        }
    }

    /**
     * Select the day to display and hide to others
     * @param event
     */
    handleSelectStep(event) {
        const stepIndex = event.params?.index;

        // hit pagination limit, do nothing
        if (stepIndex < 0 || stepIndex === this.stepsTabsTargets.length) {
            return;
        }
        this.stepsTabsTargets.forEach((tab) => {
            tab.classList.remove(
                'border-b-4',
                'border-blue-brand',
                'border-solid',
                'text-content-brand',
                'font-semibold',
            );
        });
        this.stepsTabsTargets[stepIndex].classList.add(
            'border-b-4',
            'border-blue-brand',
            'border-solid',
            'text-content-brand',
            'font-semibold',
        );
        this.stepsContentsTargets.forEach((s) => {
            s.classList.add('hidden');
        });
        this.stepsContentsTargets[stepIndex].classList.remove('hidden');
        this.stepsTabsTargets[stepIndex].scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest',
        });
    }

    /**
     * This helper function:
     * Traverses up the DOM tree through offset parents
     * Accumulates all offsetTop values
     * Provides the same value as jQuery's offset().top
     * @param element
     * @returns {number}
     */
    getOffsetTop(element) {
        let offsetTop = 0;
        while (element) {
            offsetTop += element.offsetTop;
            element = element.offsetParent;
        }
        return offsetTop;
    }

    smoothScroll(event) {
        const target = document.querySelector(
            event.currentTarget.getAttribute('href'),
        );
        const headerOffset = this.navContainerTarget.clientHeight || 0;
        event.preventDefault();

        // Usage in smoothScroll:
        const thresh = Math.floor(
            this.getOffsetTop(target) - headerOffset - 10,
        );

        window.scrollTo({
            top: thresh,
            behavior: 'smooth',
        });
    }

    activateCurrentNavigationLink() {
        let latestActiveLink;
        this.navElementTargets?.forEach((linkElement) => {
            const target = document.getElementById(
                linkElement.getAttribute('href').replace('#', ''),
            );
            const scrollThreshold = Math.floor(
                this.getOffsetTop(target) -
                    this.navContainerTarget.clientHeight -
                    10,
            );
            if (target && window.scrollY >= scrollThreshold) {
                latestActiveLink = linkElement;
                //  mobile scroll current active link into viewport
                // if ($link[0]) $link[0].scrollIntoView();
            }
            linkElement.classList.remove('after:w-full', 'text-content-brand');
        });
        if (latestActiveLink) {
            latestActiveLink.classList.add(
                'after:w-full',
                'text-content-brand',
            );
        }
    }
}
